module.exports = __webpack_public_path__ + "img/cardImg02.5137807f.jpg";